// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-off';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M10.538 13.044h.005a2.295 2.295 0 0 0 2.855-.313l.32-.321a.765.765 0 0 0 0-1.082l-1.35-1.351a.765.765 0 0 0-1.082 0 .766.766 0 0 1-1.082 0L8.04 7.813a.764.764 0 0 1 0-1.081.765.765 0 0 0 0-1.082L6.69 4.299a.765.765 0 0 0-1.082 0l-.321.321a2.294 2.294 0 0 0-.313 2.855v.005a20.716 20.716 0 0 0 5.564 5.564z' />
    <path d='M14.656 3.344 3.344 14.656M1 9a8 8 0 1 0 16 0A8 8 0 0 0 1 9z' />
  </g>
);

export const viewBox = '0 0 18 18';
